/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  GetFeatureAccessQueryResponse,
  GetFeatureAccessPathParams,
} from "../types/GetFeatureAccess.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const getFeatureAccessQueryKey = (
  organizationId: GetFeatureAccessPathParams["organizationId"] | undefined,
  featureKey: GetFeatureAccessPathParams["featureKey"] | undefined
) =>
  [
    {
      url: "/v1/access-management/organizations/:organizationId/features/:featureKey",
      params: { organizationId: organizationId, featureKey: featureKey },
    },
  ] as const

export type GetFeatureAccessQueryKey = ReturnType<
  typeof getFeatureAccessQueryKey
>

/**
 * @summary Get feature access
 * {@link /v1/access-management/organizations/:organizationId/features/:featureKey}
 */
export async function getFeatureAccess(
  organizationId: GetFeatureAccessPathParams["organizationId"],
  featureKey: GetFeatureAccessPathParams["featureKey"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetFeatureAccessQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/access-management/organizations/${organizationId}/features/${featureKey}`,
    ...requestConfig,
  })
  return res
}

export function getFeatureAccessQueryOptions(
  organizationId: GetFeatureAccessPathParams["organizationId"] | undefined,
  featureKey: GetFeatureAccessPathParams["featureKey"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getFeatureAccessQueryKey(organizationId, featureKey)
  return queryOptions<
    ResponseConfig<GetFeatureAccessQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetFeatureAccessQueryResponse>,
    typeof queryKey
  >({
    enabled: !!(organizationId && featureKey),
    queryKey,
    queryFn: async ({ signal }) => {
      return getFeatureAccess(organizationId!, featureKey!, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Get feature access
 * {@link /v1/access-management/organizations/:organizationId/features/:featureKey}
 */
export function useGetFeatureAccess<
  TData = ResponseConfig<GetFeatureAccessQueryResponse>,
  TQueryData = ResponseConfig<GetFeatureAccessQueryResponse>,
  TQueryKey extends QueryKey = GetFeatureAccessQueryKey,
>(
  organizationId: GetFeatureAccessPathParams["organizationId"] | undefined,
  featureKey: GetFeatureAccessPathParams["featureKey"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetFeatureAccessQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    getFeatureAccessQueryKey(organizationId, featureKey)

  const query = useQuery(
    {
      ...getFeatureAccessQueryOptions(organizationId, featureKey, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
